export default "__VITE_ASSET__Thc0HvA7__"